<template>
  <div class="row wrapper-picture_hp hide-on-small-only">
    <span class="copyright" role="droit auteur photo" aria-label="droit auteur photo">Illustration : IStockPhoto</span>
  </div>
</template>
<script>
export default {
  name: "Hero",
  data: () => ({})
};
</script>
<style lang="scss" scoped>
.wrapper-picture_hp {
  background-image: url("../../assets/images/hp.jpg");
  width: 100%;
  height: 350px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 25% 86%;

  .copyright {
    position: absolute;
    top: 450px;
    left: -44px;
    color: white;
    transform: rotate(-90deg);
    margin: 0;
    padding: 0;
    font-size: 10px;
    font-weight: 100;
  }
}
@media screen and (max-width: 992px) {
  .wrapper-picture_hp {
    height: 150px;

    .copyright {
      position: absolute;
      top: 250px;
      left: -38px;
      color: white;
      transform: rotate(-90deg);
      margin: 0;
      padding: 0;
      font-size: 9px;
      font-weight: 100;
    }
  }
}
</style>
